// extracted by mini-css-extract-plugin
export var videoWrapper = "decorativeVideo-module--videoWrapper--e2903";
export var vimeoPlayer = "decorativeVideo-module--vimeoPlayer--2fae1";